import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { DDTopic, DDSubTopic, DDLearningOC, DDSystem, DDStream, DDSubSytem } from "../../ReusableComponents/QBDropdowns";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { DDGradeChapter } from "../../ReusableComponents/NCLAdminDropdowns";
import notify from "../../ReusableComponents/ToastifyAlerts";
import * as Yup from "yup";

const AddEditParameters = (props) => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [ErrorMessage, setErrors] = useState({});
  const [onchangeedit, setonchangeedit] = useState(props.EditValues?.lovDescription)
  // Below is for Math
  const [Topic, SeTopic] = useState(props.EditValues?.topicId);
  const [SubTopic, SeSubTopic] = useState(props.EditValues?.subtopicId);
  const [Grade, SeGrade] = useState(props.EditValues?.gradeId);
  const [Chapter, SeChapter] = useState(props.EditValues?.chapterId);
  const [LearningOutcome, SeLeaningOutcome] = useState(props.EditValues?.learningOutcomeId);
  const[Description,SetDescription]=useState(props.EditValues?.description);
  // Below is for science
  const [System, SetSystem] = useState(props.EditValues?.systemId);
  const [Stream, SetStream] = useState(props.EditValues?.streamId);
  const [SubSystem, SetSubSystem] = useState(props.EditValues?.subSystemId);

  const GetParentLOVId = () => {
    switch (props.selectedCardId?.lovCategoryDescription) {
      case "Topic": return SubSystem;
      case "Sub Topic": return Topic;
      case "Learning Outcomes": return SubTopic;
      case "Learning Outcome": return SubTopic;
      case "Sub Learning Outcomes": return LearningOutcome;
      case "Stream": return System;
      case "Sub-System": return Stream;
    }
  }

  const validationSchema = Yup.object().shape({
    System: Yup.string().when("AVType", {
      is: () => System === "",
      then: (schema) => schema.required("System is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    Stream: Yup.string().when("AVType", {
      is: () => Stream === "",
      then: (schema) => schema.required("Stream is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    SubSystem: Yup.string().when("AVType", {
      is: () =>SubSystem === "",
      then: (schema) => schema.required("Sub-System is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    Topic: Yup.string().when("AVType", {
      is: () => Topic === "",
      then: (schema) => schema.required("Topic is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    SubTopic: Yup.string().when("AVType", {
      is: () => SubTopic === "",
      then: (schema) => schema.required("Sub-Topic is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    LearningOutcome: Yup.string().when("AVType", {
      is: () => LearningOutcome === "",
      then: (schema) => schema.required("LearningOutcome is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    onchangeedit: Yup.string()
      .required("Parameter Value is required")
      .test(
        "no-start-space",
        "Parameter Value cannot start with a space",
        (value) => !/^\s/.test(value)
      ),
    Grade: Yup.string().when("AVType", {
      is: () => (props.selectedCardId?.lovCategoryDescription === "Learning Outcomes"
        || props.selectedCardId?.lovCategoryDescription === "Learning Outcome"),
      then: (schema) => schema.required("Grade is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    Chapter: Yup.string().when("AVType", {
      is: () => (props.selectedCardId?.lovCategoryDescription === "Learning Outcomes"
        || props.selectedCardId?.lovCategoryDescription === "Learning Outcome"),
      then: (schema) => schema.required("Chapter is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    Description: Yup.string().when("AVType", {
      is: () => (props.selectedCardId?.lovCategoryDescription === "NCERT Learning Outcome"),
      then: (schema) => schema.required("Description is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });


  const PostAddLovDetails = async () => {
    if (props.EditValues) {
      const EditLovDetails = {
        "id": 0,
        "lovId": props.EditValues?.lovId,
        "lovCategoryId": props.selectedCardId?.lovCategoryId,
        "loLovId": 0,
        "parentLovId": GetParentLOVId(),
        "grade": Grade || "",
        "subjectId": 0,
        "ncertid": 0,
        "lovName": onchangeedit,
        "lovDescription": onchangeedit,
        "chapter": Chapter?.toString() || "",
        "context1": 0,
        "context2": 0,
        "subCompetenciesTitle": 0,
        "subCompetenciesTitleName": "",
        "description": Description|| "",
        "isActive": 1,
        "modifiedBy": items?.userId,
        "lovDescriptionInHindi": ""
      }
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/UpdateLov",
          EditLovDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          props.handleCardClick(props.selectedCardId);
          props.CloseForm()
          notify("Parameter Updated Successfully", "success");

        })
        .catch((err) => {
          console.log(err);
          notify("Error while Updating", "error");
        });
    }
    else {
      const AddLovDetails = {
        "lovCategoryId": props.selectedCardId?.lovCategoryId,
        "loLovId": 0,
        "parentLovId": GetParentLOVId(),
        "grade": Grade || "",
        "subjectId": 0,
        "lovName": onchangeedit,
        "lovDescription": onchangeedit,
        "chapter": Chapter?.toString() || "",
        "context1": 0,
        "context2": 0,
        "subCompetenciesTitle": 0,
        "subCompetenciesTitleName": "string",
        "description": Description||"",
        "isActive": 1,
        "createdBy": items?.userId,
        "lovDescriptionInHindi": ""
      }
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLadmin/SaveLov",
          AddLovDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          props.handleCardClick(props.selectedCardId);
          props.CloseForm()
          notify("Parameter Added Successfully", "success");

        })
        .catch((err) => {
          console.log(err);
          notify("Error while Adding", "error");
        });
    }
  };
  const Validation = () => {
    const AllFields = {
      onchangeedit, Topic, SubTopic, Grade, Chapter, LearningOutcome, System,
      Stream, SubSystem,Description
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
        PostAddLovDetails();
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        setErrors(newErrors);
      });
  };

  console.log("props.EditValues",props.EditValues)
  return (
    <>
      <div className="Card p-4 w-50">
        <div className="dflex alignitems JSBetween">
          <div className="MainHeading">{props.EditValues ? "Edit" : "Add"} Parameter
          </div>
          <IoMdCloseCircleOutline onClick={() => props.Cancle(false)} style={{ fontSize: '24px' }} />
        </div>
        <div className="Parameter-Options mt-2">

          {props.fetchedParameters?.[0]?.systemId !== 0 &&
            <div>
              <DDSystem
                className="NCLDropdown w-100"
                SubjectId={props.SubjectId.toString()}
                LID={props.LanguageId}
                NCLAdmin={true}
                Displayname="Select System"
                SOption={System}
                StoreValue={SetSystem}
                onChange={(e) => SetSystem(e)}
                name="System"
              />
              {ErrorMessage.System && (
                <div className="error-message">{ErrorMessage.System}</div>
              )}
            </div>}
          {props.fetchedParameters?.[0]?.streamId !== 0 &&
            <div>
              <DDStream
                className="NCLDropdown w-100"
                SubjectId={props.SubjectId.toString()}
                LID={props.LanguageId}
                NCLAdmin={true}
                PId={System}
                Displayname="Select Stream"
                SOption={Stream}
                StoreValue={SetStream}
                onChange={(e) => SetStream(e)}
                name="Stream"
              />
              {ErrorMessage.Stream && (
                <div className="error-message">{ErrorMessage.Stream}</div>
              )}
            </div>}
          {props.fetchedParameters?.[0]?.subSystemId !== 0 &&
            <div>
              <DDSubSytem
                className="NCLDropdown w-100"
                SubjectId={props.SubjectId.toString()}
                LID={props.LanguageId}
                NCLAdmin={true}
                PId={Stream}
                Displayname="Select Sub-System"
                SOption={SubSystem}
                StoreValue={SetSubSystem}
                onChange={(e) => SetSubSystem(e)}
                name="SubSystem"
              />
              {ErrorMessage.SubSystem && (
                <div className="error-message">{ErrorMessage.SubSystem}</div>
              )}
            </div>}
          {props.fetchedParameters?.[0]?.topicId !== 0 &&
            <div>
              <DDTopic
                className="NCLDropdown w-100"
                SubjectId={props.SubjectId.toString()}
                LovCategoryId={props.SubjectId.toString() === "1" ? 4 : 25}
                LID={props.LanguageId}
                SOption={Topic}
                labelName={
                  <div className="DropdownHeader">
                    Topic<span>*</span>
                  </div>
                }
                PId={SubSystem}
                Displayname="Select Topic"
                StoreValue={SeTopic}
                onChange={(e) => SeTopic(e)}
                name="Topic"
              />
              {ErrorMessage.Topic && (
                <div className="error-message">{ErrorMessage.Topic}</div>
              )}
            </div>
          }

          {props.fetchedParameters?.[0]?.subtopicId !== 0 &&
            <div>
              <DDSubTopic
                className="NCLDropdown w-100"
                SubjectId={props.SubjectId.toString()}
                LovCategoryId={props.SubjectId.toString() === "1" ? 5 : 26}
                LID={props.LanguageId}
                PId={Topic} SOption={SubTopic}
                labelName={
                  <div className="DropdownHeader">
                    Sub Topic<span>*</span>
                  </div>
                }
                Displayname="Select Sub-Topic"
                StoreValue={SeSubTopic}
                onChange={(e) => SeSubTopic(e)}
                name="SubTopic"
              />
              {ErrorMessage.SubTopic && (
                <div className="error-message">{ErrorMessage.SubTopic}</div>
              )}
            </div>
          }
          {props.fetchedParameters?.[0]?.learningOutcomeId !== 0 &&
            <div>
              <DDLearningOC
                className="NCLDropdown w-100"
                SubjectId={props.SubjectId.toString()}
                LovCategoryId={props.SubjectId.toString() === "1" ? 40 : 27}
                LID={props.LanguageId}
                PId={SubTopic || props.EditValues?.subtopicId}
                SOption={LearningOutcome}
                labelName={
                  <div className="DropdownHeader">
                    Learning Outcomes<span>*</span>
                  </div>
                }
                Displayname="Select Learning Outcomes"

                StoreValue={SeLeaningOutcome}
                onChange={(e) => SeLeaningOutcome(e)}
                name="LearningOutcome"
              />
              {ErrorMessage.LearningOutcome && (
                <div className="error-message">{ErrorMessage.LearningOutcome}</div>
              )}
            </div>}

          <div>
            <div className="DropdownHeader">
              {props.selectedCardId?.lovCategoryDescription}<span>*</span>
            </div>
            <input
              type="text" className="NCLDropdown w-100"
              // defaultValue={row.description}
              value={onchangeedit}
              onChange={(e) => setonchangeedit(e.target.value)}
              style={{ textAlign: 'justify' }}
              name="Textbox"
            />
            {ErrorMessage.onchangeedit && (
              <div className="error-message">{ErrorMessage.onchangeedit}</div>
            )}
          </div>
           {props.fetchedParameters?.[0]?.description &&
          <div>
            <div className="DropdownHeader">Description<span>*</span>
            </div>
            <input
              type="text" className="NCLDropdown w-100"
              // defaultValue={row.description}
               value={Description}
               onChange={(e) => SetDescription(e.target.value)}
              style={{ textAlign: 'justify' }}
              name="Textbox"
            />
            {ErrorMessage.Description && (
              <div className="error-message">{ErrorMessage.Description}</div>
            )}
          </div>}
          {(props.selectedCardId?.lovCategoryDescription === "Learning Outcomes" || props.selectedCardId?.lovCategoryDescription === "Learning Outcome") &&
            <>
              <div>
                <DDGradeChapter className="NCLDropdown w-100" LovCategoryId={14} LID={props.LanguageId}
                  SOption={Grade} Displayname="Select Grade"
                  labelName={<div className="DropdownHeader"> Grade<span>*</span> </div>}
                  StoreValue={SeGrade} onChange={(e) => SeGrade(e)}
                  name="Grade" />
                {ErrorMessage.Grade && (
                  <div className="error-message">{ErrorMessage.Grade}</div>
                )}
              </div>

              <div>
                <DDGradeChapter className="NCLDropdown w-100" LovCategoryId={28} LID={props.LanguageId}
                  SOption={Chapter} Displayname="Select Chapter"
                  labelName={<div className="DropdownHeader"> Chapter<span>*</span> </div>}
                  StoreValue={SeChapter} onChange={(e) => SeChapter(e)}
                  name="Chapter" />
                {ErrorMessage.Chapter && (
                  <div className="error-message">{ErrorMessage.Chapter}</div>
                )}
              </div></>
          }
        </div>

        <div className="AddStudent-Buttons dflex mt-3">
          <button className="Buttons" onClick={Validation}>
            {props.EditValues ? "Update" : "Save"}
          </button>
          <button className="Buttons CancleButton" onClick={() => props.Cancle(false)}>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};
export default AddEditParameters;